function formatarDataIsoLocal(data: Date): string {
  const ano = data.getFullYear();
  const mes = String(data.getMonth() + 1).padStart(2, "0");
  const dia = String(data.getDate()).padStart(2, "0");
  return `${ano}-${mes}-${dia}`;
}

export function obterIntervaloMesAtual(): { dataInicio: string; dataFim: string } {
  const agora = new Date();
  const primeiroDia = new Date(agora.getFullYear(), agora.getMonth(), 1);
  const ultimoDia = new Date(agora.getFullYear(), agora.getMonth() + 1, 0);

  return {
    dataInicio: formatarDataIsoLocal(primeiroDia),
    dataFim: formatarDataIsoLocal(ultimoDia),
  };
}
